import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'interiorPackages', 'steeringWheels'],
};

const sq6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron: PartialCarConfiguration = {
	...q6,
};

export { q6etron, sq6etron };
